// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"27115902","268":"4fb6eaee","404":"2fd1372e","577":"a4f51422"}[chunkId] + ".chunk.js";
};